import OrderFlowKitchenPage from "./OrderFlowKitchenPage";

export {OrderFlowKitchenPage}
export default OrderFlowKitchenPage
